import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { GroupSizeFilterControl } from "@/components/AgendaFilters";
import { useDepartmentGolfFacilitiesGroupSize } from "@/features/Department";

import { DepartmentAvailabilityGroupSizeSelect_department$key } from "./__generated__/DepartmentAvailabilityGroupSizeSelect_department.graphql";

type Props = {
  departmentRef: DepartmentAvailabilityGroupSizeSelect_department$key | null;
  onChange: (value: number | undefined) => void;
  groupSize: number | undefined;
};
export const DepartmentAvailabilityGroupSizeSelect = ({
  onChange,
  departmentRef,
  groupSize,
}: Props) => {
  const department = useFragment(
    DepartmentAvailabilityGroupSizeSelectFragmentString,
    departmentRef
  );
  const departmentGroupSizes = useDepartmentGolfFacilitiesGroupSize(
    department ?? null
  );

  return (
    <GroupSizeFilterControl
      controlMinGroupSize={departmentGroupSizes.min}
      controlMaxGroupSize={departmentGroupSizes.max}
      onChange={onChange}
      selectedGroupSize={groupSize}
    />
  );
};

const DepartmentAvailabilityGroupSizeSelectFragmentString = graphql`
  fragment DepartmentAvailabilityGroupSizeSelect_department on Department {
    ...useDepartmentGolfFacilitiesGroupSize_department
  }
`;
